module.exports = __webpack_public_path__ + "img/extended.0f00b2ea.png";